import { defineStore } from "pinia";
import Api from "@/utils/api/supabaseStorageUpload";

export const useSupabaseStorageUploadStore = defineStore(
  "supabase_storage_upload_store",
  {
    state: () => ({
      isUploading: false,
      error: null
    }),

    actions: {
      async uploadFormAttachment(file) {
        this.isUploading = true;
        this.error = null;

        try {
          const result = await Api.handleFormAttachmentUpload(file);

          if (result.error) {
            this.error = result.error;
            throw new Error(result.error);
          }

          return result;
        } catch (error) {
          this.error = error.message || "Upload failed";
          throw error;
        } finally {
          this.isUploading = false;
        }
      }
    }
  }
);
